// pages/AgendaPage.js o donde desees usarlo
import React from 'react';
import { Box } from '@mui/material';
import ManifiestosDashboardBase from '../../components/administration/manifests/ManifestDashboardBase';

const ManifiestosInternosPage = () => {
    return (
        <Box sx={{ p: 2 }}>
            {/*<ManifiestosDashboardBase tipo="internos" title="Manifiestos Internos"
                onReorder={(newOrder) => {
                    console.log('Nuevo orden de Manifiestos Internos', newOrder);
                }}
            />*/}
            <ManifiestosDashboardBase
                serProInt
                tipoServicioCodigo="TRANSPORTE_PERSONAL"
                title="Gestión de Manifiestos Internos"
                allowBulkCreation
            />
        </Box>
    );
};

export default ManifiestosInternosPage;
